import { render, staticRenderFns } from "./v-sliderFoto.vue?vue&type=template&id=1a119c22&"
import script from "./v-sliderFoto.vue?vue&type=script&lang=js&"
export * from "./v-sliderFoto.vue?vue&type=script&lang=js&"
import style0 from "./v-sliderFoto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCard } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VApp,VCard,VRow,VSheet,VSlideGroup})
